(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hf-cadou-alb"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var r = document.querySelector('[data-hfa]');
  if (!r) return;

  /* după sfârșitul campaniei nu apare deloc (Liquid o oprește la randare; asta
     acoperă paginile deja încărcate sau ținute în cache) */
  var sfarsit = Date.parse(r.dataset.sfarsit || '');
  if (sfarsit && Date.now() > sfarsit) { r.parentNode && r.parentNode.removeChild(r); return; }

  var CHEIE_ABONAT = 'hfAlbAbonat';
  var CHEIE_INCHIS = 'hfAlbInchis';
  /* ⚠️ ADĂUGAT 9 octombrie 2026 — vezi mai jos, la „când apare". */
  var CHEIE_ARATAT = 'hfAlbAratat';

  var firma = r.dataset.firma;
  var lista = r.dataset.lista;
  var intarziere = parseInt(r.dataset.intarziere, 10) || 20;
  var zile = parseInt(r.dataset.zile, 10) || 14;
  var laIesire = r.dataset.iesire === '1';

  var incet = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var confeti = r.querySelector('.hfa__confeti');
  var alegere = r.querySelector('.hfa__alegere');
  var deschisa = false;
  var inchisaAici = false;   /* a închis-o cu X pe pagina asta */
  var incercari = 0;
  var deUnde = null;

  /* localStorage poate arunca (fereastră privată, date blocate) — nimic din
     fereastră nu trebuie să depindă de el. */
  function ia(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function pune(k, v) { try { localStorage.setItem(k, v); } catch (e) { /* nimic */ } }

  function arata(n) {
    r.querySelectorAll('.hfa__pas').forEach(function (p) {
      p.classList.toggle('hfa--activ', p.dataset.pas === String(n));
    });
  }

  /* ─── confetti ───
     ⚠️ fără crem: pe pergament hârtiuțele crem sunt invizibile */
  var CULORI = ['#c8912f', '#e0b45a', '#9a3f1c', '#b8521f', '#a8761f', '#d9a441'];
  function arunca(cate) {
    if (incet) return;
    confeti.innerHTML = '';
    for (var i = 0; i < cate; i++) {
      var b = document.createElement('i');
      var unghi = (Math.PI * (0.08 + 0.84 * (i / cate))) + (Math.random() - 0.5) * 0.35;
      var forta = 110 + Math.random() * 150;
      b.style.setProperty('--dx', Math.round(Math.cos(unghi) * forta * -1) + 'px');
      b.style.setProperty('--dy', Math.round(-Math.abs(Math.sin(unghi)) * forta - 30) + 'px');
      b.style.setProperty('--rot', Math.round((Math.random() - 0.5) * 900) + 'deg');
      b.style.background = CULORI[i % CULORI.length];
      b.style.animationDelay = (Math.random() * 0.18).toFixed(2) + 's';
      b.style.animationDuration = (1.3 + Math.random() * 0.7).toFixed(2) + 's';
      if (i % 3 === 0) { b.style.borderRadius = '50%'; b.style.width = '8px'; b.style.height = '8px'; }
      confeti.appendChild(b);
    }
    setTimeout(function () { confeti.innerHTML = ''; }, 2400);
  }

  /* ─── Klaviyo ─── */
  function eAdresa(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v); }

  function semnal(nume, date) {
    try {
      fetch('https://a.klaviyo.com/client/events/?company_id=' + firma, {
        method: 'POST', keepalive: true,
        headers: { 'Content-Type': 'application/json', revision: '2025-07-15' },
        body: JSON.stringify({ data: { type: 'event', attributes: {
          metric: { data: { type: 'metric', attributes: { name: nume } } },
          properties: date || {},
          profile: { data: { type: 'profile', attributes: date && date.email ? { email: date.email } : { anonymous_id: 'fereastra-white-friday' } } },
        } } }),
      }).catch(function () { /* semnalele nu blochează nimic */ });
    } catch (e) { /* nimic */ }
  }

  function aboneaza(adresa) {
    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + firma, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: '2025-07-15' },
      body: JSON.stringify({ data: { type: 'subscription', attributes: {
        custom_source: 'Fereastra White Friday',
        profile: { data: { type: 'profile', attributes: { email: adresa } } },
      }, relationships: { list: { data: { type: 'list', id: lista } } } } }),
    });
  }

  /* ─── răzuitul ───
     Stratul negru se desenează de fiecare dată când se deschide fereastra.
     Peste ~45% răzuit, restul dispare singur și apare darul. */
  var CHEIE_RAZUIT = 'hfAlbRazuit';   /* a răzuit o dată — data viitoare, direct la −25% */
  var razuit = r.querySelector('[data-hfa-razuit]');
  var strat = r.querySelector('[data-hfa-strat]');
  var ctx = null, latS = 0, inaltS = 0, scara = 1, apasat = false, ultim = null, miscari = 0;
  var dezvaluit = false, aInceput = false;

  function deseneazaStratul() {
    latS = razuit.offsetWidth; inaltS = razuit.offsetHeight;
    if (!latS || !inaltS || !strat.getContext) return;
    scara = Math.min(window.devicePixelRatio || 1, 2);
    strat.width = Math.round(latS * scara); strat.height = Math.round(inaltS * scara);
    ctx = strat.getContext('2d');
    ctx.setTransform(scara, 0, 0, scara, 0, 0);
    ctx.globalCompositeOperation = 'source-over';
    var g = ctx.createLinearGradient(0, 0, latS, inaltS);
    g.addColorStop(0, '#2b2723'); g.addColorStop(0.5, '#141210'); g.addColorStop(1, '#25211d');
    ctx.fillStyle = g; ctx.fillRect(0, 0, latS, inaltS);
    for (var i = 0; i < 30; i++) {
      ctx.fillStyle = 'rgba(220,164,69,' + (0.2 + Math.random() * 0.5).toFixed(2) + ')';
      ctx.beginPath(); ctx.arc(Math.random() * latS, Math.random() * inaltS, 0.4 + Math.random() * 1.5, 0, Math.PI * 2); ctx.fill();
    }
    ctx.strokeStyle = 'rgba(220,164,69,.55)'; ctx.lineWidth = 1; ctx.strokeRect(6.5, 6.5, latS - 13, inaltS - 13);
    ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
    ctx.fillStyle = '#e8c470';
    ctx.font = "600 20px 'Playfair Display', Georgia, serif";
    ctx.fillText('✦  ' + (razuit.dataset.text || '') + '  ✦', latS / 2, inaltS / 2 - 9);
    ctx.fillStyle = 'rgba(243,226,184,.72)';
    ctx.font = "italic 13px 'Lora', Georgia, serif";
    ctx.fillText(razuit.dataset.textMic || '', latS / 2, inaltS / 2 + 17);
  }

  function pregatesteStratul() {
    dezvaluit = false; aInceput = false; miscari = 0; apasat = false;
    razuit.classList.remove('hfa--dezvaluit');
    deseneazaStratul();
    /* fonturile site-ului pot veni după prima desenare — se redesenează o dată,
       dacă omul n-a început încă să răzuiască */
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { if (!aInceput) deseneazaStratul(); });
  }

  function punct(e) {
    var dr = strat.getBoundingClientRect();
    var k = dr.width ? latS / dr.width : 1;      /* fereastra poate fi scalată de animație */
    return { x: (e.clientX - dr.left) * k, y: (e.clientY - dr.top) * k };
  }
  function zgarie(x, y) {
    ctx.globalCompositeOperation = 'destination-out';
    ctx.beginPath(); ctx.arc(x, y, 22, 0, Math.PI * 2); ctx.fill();
  }
  function catERazuit() {
    var d = ctx.getImageData(0, 0, strat.width, strat.height).data, tot = 0, gol = 0;
    for (var i = 3; i < d.length; i += 4 * 29) { tot++; if (d[i] < 40) gol++; }
    return tot ? gol / tot : 0;
  }
  function dezvaluie() {
    if (dezvaluit) return;
    dezvaluit = true; apasat = false;
    try { window.getSelection().removeAllRanges(); } catch (x) { /* nimic */ }
    razuit.classList.add('hfa--dezvaluit');
    pune(CHEIE_RAZUIT, '1');
    arunca(40);
    semnal('Fereastra White Friday — a răzuit');
    setTimeout(function () { arata(2); }, 1500);
  }
  function verifica() { if (ctx && !dezvaluit && catERazuit() > 0.45) dezvaluie(); }

  if (strat && window.PointerEvent) {
    strat.addEventListener('pointerdown', function (e) {
      if (dezvaluit || !ctx) return;
      apasat = true;
      try { strat.setPointerCapture(e.pointerId); } catch (x) { /* nimic */ }
      ultim = punct(e); zgarie(ultim.x, ultim.y);
      if (!aInceput) { aInceput = true; semnal('Fereastra White Friday — a început să răzuiască'); }
      e.preventDefault();
    });
    strat.addEventListener('pointermove', function (e) {
      if (!apasat || dezvaluit) return;
      var p = punct(e), dx = p.x - ultim.x, dy = p.y - ultim.y;
      var pasi = Math.max(1, Math.ceil(Math.sqrt(dx * dx + dy * dy) / 8));
      for (var i = 1; i <= pasi; i++) zgarie(ultim.x + dx * i / pasi, ultim.y + dy * i / pasi);
      ultim = p;
      if (++miscari % 6 === 0) verifica();
      e.preventDefault();
    });
    ['pointerup', 'pointercancel'].forEach(function (ev) {
      strat.addEventListener(ev, function () { if (apasat) { apasat = false; verifica(); } });
    });
  }
  /* fără răzuit (cititor de ecran, tastatură, browser vechi): direct la dar */
  var direct = r.querySelector('[data-hfa-direct]');
  if (direct) direct.addEventListener('click', function () { dezvaluie(); });

  /* ─── deschidere / închidere fereastră ─── */
  function deschide() {
    if (deschisa) return;
    deschisa = true;
    deUnde = document.activeElement;
    arata(ia(CHEIE_RAZUIT) ? 2 : 1);   /* a răzuit deja: direct la −25% */
    r.hidden = false;
    void r.offsetWidth;
    r.classList.add('hfa--vazuta');
    pune(CHEIE_ARATAT, String(Date.now()));
    document.body.style.overflow = 'hidden';
    var fer = r.querySelector('.hfa__fereastra');
    if (fer) { try { fer.focus({ preventScroll: true }); } catch (e) { /* nimic */ } }
    pregatesteStratul();
    semnal('Fereastra White Friday — s-a deschis');
  }

  /* `tacut` = o retragere care nu e vina omului (a apărut fereastra Klaviyo
     peste a noastră), deci nu i se ține socoteala celor 14 zile. */
  function inchide(tacut) {
    if (!deschisa) return;
    deschisa = false;
    r.classList.remove('hfa--vazuta');
    document.body.style.overflow = '';
    setTimeout(function () { r.hidden = true; }, 320);
    if (!tacut && !ia(CHEIE_ABONAT)) pune(CHEIE_INCHIS, String(Date.now()));
    if (!tacut) inchisaAici = true;
    if (!tacut && deUnde && deUnde.focus) { try { deUnde.focus({ preventScroll: true }); } catch (e) { /* nimic */ } }
  }

  r.querySelectorAll('[data-hfa-inchide]').forEach(function (b) { b.addEventListener('click', function () { inchide(false); }); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && deschisa) inchide(false); });


  /* Orice legătură către `#cadou`, de oriunde din pagină, deschide fereastra.
     Așa are subsolul unde să trimită omul, iar cine a închis-o o poate chema
     înapoi fără să aștepte cele 14 zile. */
  document.addEventListener('click', function (e) {
    var a = e.target.closest ? e.target.closest('a[href$="#cadou"]') : null;
    if (!a) return;
    e.preventDefault();
    if (deschisa) return;
    deschide();
  });

  r.querySelector('[data-hfa-mai-departe]').addEventListener('click', function () {
    arata(3);
    setTimeout(function () { var m = document.getElementById('hfaMail'); if (m) m.focus(); }, 120);
  });

  var trimite = r.querySelector('[data-hfa-trimite]');
  var eroare = r.querySelector('[data-hfa-eroare]');

  function gata(adresa) {
    pune(CHEIE_ABONAT, '1');
    arata(4);
    try { fetch('/discount/' + encodeURIComponent(r.dataset.cod), { credentials: 'same-origin' }); } catch (e) { /* nimic */ }
    arunca(26);
    semnal('Fereastra White Friday — a luat codul', { email: adresa });
  }

  trimite.addEventListener('click', function () {
    var camp = document.getElementById('hfaMail');
    var adresa = (camp.value || '').trim();

    if (!eAdresa(adresa)) {
      eroare.textContent = 'Scrie o adresă de e-mail întreagă, te rog.';
      eroare.hidden = false;
      camp.focus();
      return;
    }

    eroare.hidden = true;
    trimite.disabled = true;
    var scria = trimite.textContent;
    trimite.textContent = 'Se trimite…';

    /* ⚠️ Klaviyo răspunde 202 și pentru o adresă greșită — de asta adresa se
       verifică mai sus, nu din răspunsul lui. */
    aboneaza(adresa).then(function (rasp) {
      if (!rasp.ok) throw new Error('stare ' + rasp.status);
      gata(adresa);
    }).catch(function () {
      incercari++;
      trimite.disabled = false;
      trimite.textContent = scria;
      if (incercari >= 2) {
        /* A doua oară nu-l mai ținem în loc. Mai bine un cod dat degeaba decât
           un om pierdut în fața unui buton care nu merge. */
        gata(adresa);
        return;
      }
      eroare.textContent = 'Nu am putut trimite acum. Mai încearcă o dată.';
      eroare.hidden = false;
    });
  });

  var aplica = r.querySelector('[data-hfa-aplica]');
  if (aplica) aplica.addEventListener('click', function () {
    try { if (navigator.clipboard) navigator.clipboard.writeText(r.dataset.cod); } catch (e) { /* nimic */ }
    semnal('Fereastra White Friday — a aplicat codul');
  });

  var cod = r.querySelector('[data-hfa-copiaza]');
  var copiat = r.querySelector('[data-hfa-copiat]');
  if (cod) {
    cod.addEventListener('click', function () {
      var t = cod.textContent.trim();
      var arataCopiat = function () { copiat.hidden = false; setTimeout(function () { copiat.hidden = true; }, 2200); };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(t).then(arataCopiat).catch(function () { /* nimic */ });
      }
    });
  }

  /* ─── când apare ─── */

  /* ⚠️ REPARAT 9 octombrie 2026. `offsetParent` e ÎNTOTDEAUNA null pentru un
     element cu `position: fixed` — iar bannerul de cookie-uri al Shopify e fix.
     Deci paza de mai jos credea mereu că bannerul NU e pe ecran, și fereastra
     se deschidea peste el. Măsurat pe viu: se suprapuneau. Acum ne uităm la
     stilul calculat și la dreptunghi, care merg pentru orice poziționare. */
  function vazut(e) {
    if (!e) return false;
    var st = getComputedStyle(e);
    if (st.display === 'none' || st.visibility === 'hidden' || parseFloat(st.opacity) < 0.05) return false;
    var dr = e.getBoundingClientRect();
    return dr.width > 0 && dr.height > 0;
  }

  /* ⚠️ Niciodată peste bannerul de cookie-uri. Acolo omul dă un consimțământ,
     iar o fereastră care îl acoperă e și enervantă, și o problemă în sine.
     Se așteaptă până îl rezolvă — dar nu la nesfârșit. */
  function bannerSus() { return vazut(document.querySelector('#shopify-pc__banner')); }

  /* ⚠️ ȘI NICIODATĂ PESTE FEREASTRA KLAVIYO.
     Cât timp formularul lor (`UL7CPr`, cel cu meditația) e publicat, omul
     le-ar primi pe amândouă deodată — s-a și văzut, una peste alta. Formularele
     Klaviyo nu se pot opri prin API, doar din contul ei, deci fereastra asta se
     dă singură la o parte până dispare cealaltă. În clipa în care o stinge, a
     noastră își face treaba fără să mai umble nimeni la temă. */
  function klaviyoSus() { return vazut(document.querySelector('.klaviyo-form')); }

  /* 29 oct. 2026 — Xenia: „pe niciun magazin să nu apară pop-up-ul în timp ce faci un chestionar".
     Orice chestionar: al frecvențelor (#chest-card) și al frecvenței personalizate (hf-fp). Cât e pe ecran,
     fereastra așteaptă; cine l-a atins n-o mai vede pe pagina asta. (paza-chestionar.js) */
  var SEL_CHESTIONAR = '#chest-card, .hf-fp-section, [data-hf-fp-pas]';
  function chestionarPeEcran() {
    var q = document.querySelectorAll(SEL_CHESTIONAR);
    for (var i = 0; i < q.length; i++) {
      var dr = q[i].getBoundingClientRect();
      if (dr.width > 0 && dr.height > 0 && dr.bottom > 0 && dr.top < window.innerHeight) return true;
    }
    return false;
  }

  function deschideCandSePoate(ramase) {
    if (deschisa || inchisaAici || inChestionar) return;
    if ((bannerSus() || klaviyoSus() || chestionarPeEcran()) && ramase > 0) {
      setTimeout(function () { deschideCandSePoate(ramase - 1); }, 4000);
      return;
    }
    if (klaviyoSus() || chestionarPeEcran()) return;   /* a trecut vremea și tot e acolo — tăcem */
    deschide();
  }

  /* ⚠️ ADĂUGAT 27 oct. 2026, seara — Xenia: „dacă face cineva chestionarul, poți face să nu apară
     pop-up-ul?" Cine a atins chestionarul (#chest-card, pe pagina frecvențelor) n-o mai vede pe pagina
     aceea, nici cât răspunde, nici la rezultat. Cine și-a lăsat e-mailul în chestionar n-o mai vede
     niciodată: e deja în mailurile chestionarului. Cine l-a terminat fără e-mail o vede iar pe pagina
     următoare, ca pe oricine. Ascultăm în faza de captură: butonul „Vezi rezultatul" e scos din pagină
     de chestionar chiar în clic, iar în faza obișnuită n-ar mai avea de unde citi adresa. */
  var CHEIE_CHESTIONAR = 'hfAlbChestionar';
  if (ia(CHEIE_ABONAT) || ia(CHEIE_CHESTIONAR)) return;
  var inChestionar = false;
  function atingeChestionarul(e) {
    var card = e.target && e.target.closest && e.target.closest(SEL_CHESTIONAR);
    if (!card) return;
    inChestionar = true;
    if (e.type === 'click' && e.target.closest('[data-vezi]')) {
      var em = card.querySelector('[data-email]');
      if (em && /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(em.value.trim())) pune(CHEIE_CHESTIONAR, '1');
    }
  }
  document.addEventListener('click', atingeChestionarul, true);
  document.addEventListener('input', atingeChestionarul, true);
  /* ⚠️ SCHIMBAT 27 octombrie 2026, la cererea Xeniei: „să apară la 30 de
     secunde pe toate paginile și să se tot repete până când omul răzuiește.
     Dacă a dat X, să apară iar când schimbă pagina. Dacă a completat, să nu mai
     apară niciodată." Deci aici NU mai sunt pauzele ferestrei vechi (14 zile
     după X, 24 de ore după ce s-a arătat). Pauza de 24 de ore fusese pusă pe 9
     oct., când fereastra apărea la fiecare pagină și se vedeau 1,02 pagini pe
     sesiune — de urmărit în Clarity, paginile pe sesiune, cât ține campania. */

  var cronometru = setTimeout(function () { deschideCandSePoate(45); }, intarziere * 1000);

  /* ⚠️ Nu e de ajuns să ne uităm o dată, înainte de a deschide: fereastra
     Klaviyo apare DUPĂ a noastră, și atunci se suprapun. S-a văzut cu ochii.
     Deci stăm de veghe: dacă apare cât timp a noastră e deschisă și omul încă
     n-a atins nimic, ne retragem tăcut și nu-i ținem socoteala zilelor. */
  var veghe = setInterval(function () {
    if (klaviyoSus() && deschisa) {
      var laInceput = r.querySelector('.hfa__pas--1.hfa--activ');
      if (laInceput) inchide(true);
    }
    if (performance.now() > 180000) clearInterval(veghe);
  }, 1500);

  if (laIesire && window.matchMedia('(min-width: 900px)').matches) {
    document.addEventListener('mouseout', function (e) {
      if (e.clientY <= 0 && !e.relatedTarget && !deschisa && !inchisaAici && !inChestionar && !chestionarPeEcran() && !bannerSus() && !klaviyoSus()) {
        clearTimeout(cronometru);
        deschide();
      }
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hf-cadou"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var r = document.querySelector('[data-hfc]');
  if (!r) return;

  var CHEIE_ABONAT = 'hfCadouAbonat';
  var CHEIE_INCHIS = 'hfCadouInchis';
  /* ⚠️ ADĂUGAT 9 octombrie 2026 — vezi mai jos, la „când apare". */
  var CHEIE_ARATAT = 'hfCadouAratat';

  var firma = r.dataset.firma;
  var lista = r.dataset.lista;
  var intarziere = parseInt(r.dataset.intarziere, 10) || 20;
  var zile = parseInt(r.dataset.zile, 10) || 14;
  var laIesire = r.dataset.iesire === '1';

  var incet = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var confeti = r.querySelector('.hfc__confeti');
  var alegere = r.querySelector('.hfc__alegere');
  var deschidere = r.querySelector('.hfc__deschidere');
  var deschisa = false;
  var incercari = 0;
  var deUnde = null;

  /* localStorage poate arunca (fereastră privată, date blocate) — nimic din
     fereastră nu trebuie să depindă de el. */
  function ia(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function pune(k, v) { try { localStorage.setItem(k, v); } catch (e) { /* nimic */ } }

  function arata(n) {
    r.querySelectorAll('.hfc__pas').forEach(function (p) {
      p.classList.toggle('hfc--activ', p.dataset.pas === String(n));
    });
  }

  /* ─── confetti ───
     ⚠️ fără crem: pe pergament hârtiuțele crem sunt invizibile */
  var CULORI = ['#c8912f', '#e0b45a', '#9a3f1c', '#b8521f', '#a8761f', '#d9a441'];
  function arunca(cate) {
    if (incet) return;
    confeti.innerHTML = '';
    for (var i = 0; i < cate; i++) {
      var b = document.createElement('i');
      var unghi = (Math.PI * (0.08 + 0.84 * (i / cate))) + (Math.random() - 0.5) * 0.35;
      var forta = 110 + Math.random() * 150;
      b.style.setProperty('--dx', Math.round(Math.cos(unghi) * forta * -1) + 'px');
      b.style.setProperty('--dy', Math.round(-Math.abs(Math.sin(unghi)) * forta - 30) + 'px');
      b.style.setProperty('--rot', Math.round((Math.random() - 0.5) * 900) + 'deg');
      b.style.background = CULORI[i % CULORI.length];
      b.style.animationDelay = (Math.random() * 0.18).toFixed(2) + 's';
      b.style.animationDuration = (1.3 + Math.random() * 0.7).toFixed(2) + 's';
      if (i % 3 === 0) { b.style.borderRadius = '50%'; b.style.width = '8px'; b.style.height = '8px'; }
      confeti.appendChild(b);
    }
    setTimeout(function () { confeti.innerHTML = ''; }, 2400);
  }

  /* ─── Klaviyo ─── */
  function eAdresa(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v); }

  function semnal(nume, date) {
    try {
      fetch('https://a.klaviyo.com/client/events/?company_id=' + firma, {
        method: 'POST', keepalive: true,
        headers: { 'Content-Type': 'application/json', revision: '2025-07-15' },
        body: JSON.stringify({ data: { type: 'event', attributes: {
          metric: { data: { type: 'metric', attributes: { name: nume } } },
          properties: date || {},
          profile: { data: { type: 'profile', attributes: date && date.email ? { email: date.email } : { anonymous_id: 'fereastra-cadou' } } },
        } } }),
      }).catch(function () { /* semnalele nu blochează nimic */ });
    } catch (e) { /* nimic */ }
  }

  function aboneaza(adresa) {
    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + firma, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: '2025-07-15' },
      body: JSON.stringify({ data: { type: 'subscription', attributes: {
        custom_source: 'Fereastra de cadou',
        profile: { data: { type: 'profile', attributes: { email: adresa } } },
      }, relationships: { list: { data: { type: 'list', id: lista } } } } }),
    });
  }

  /* ─── deschiderea cutiei ─── */
  function deschideCutia() {
    semnal('Fereastra cadou — a ales o cutie');
    if (incet) { arata(2); return; }

    alegere.style.transition = 'opacity .24s';
    alegere.style.opacity = '0';

    setTimeout(function () {
      alegere.style.display = 'none';
      deschidere.classList.add('hfc--activ');
      /* ⚠️ Citirea asta silește browserul să recalculeze aranjarea ACUM, ca
         afișarea și clasa de tremurat să nu cadă în același pas de randare.
         Nu se face cu requestAnimationFrame: sunt browsere și situații în care
         nu rulează deloc, și atunci cutia ar rămâne nemișcată. */
      void deschidere.offsetWidth;
      deschidere.classList.add('hfc--suspans');
    }, 250);

    setTimeout(function () {
      deschidere.classList.remove('hfc--suspans');
      deschidere.classList.add('hfc--deschisa');
      arunca(42);
    }, 1560);

    setTimeout(function () { arata(2); }, 2180);
  }

  /* ─── deschidere / închidere fereastră ─── */
  function deschide() {
    if (deschisa) return;
    deschisa = true;
    deUnde = document.activeElement;
    arata(1);
    r.hidden = false;
    void r.offsetWidth;
    r.classList.add('hfc--vazuta');
    pune(CHEIE_ARATAT, String(Date.now()));
    document.body.style.overflow = 'hidden';
    var intai = r.querySelector('[data-hfc-alege]');
    if (intai) { try { intai.focus({ preventScroll: true }); } catch (e) { intai.focus(); } }
    semnal('Fereastra cadou — s-a deschis');
  }

  /* `tacut` = o retragere care nu e vina omului (a apărut fereastra Klaviyo
     peste a noastră), deci nu i se ține socoteala celor 14 zile. */
  function inchide(tacut) {
    if (!deschisa) return;
    deschisa = false;
    r.classList.remove('hfc--vazuta');
    document.body.style.overflow = '';
    setTimeout(function () { r.hidden = true; }, 320);
    if (!tacut && !ia(CHEIE_ABONAT)) pune(CHEIE_INCHIS, String(Date.now()));
    if (!tacut && deUnde && deUnde.focus) { try { deUnde.focus({ preventScroll: true }); } catch (e) { /* nimic */ } }
  }

  r.querySelectorAll('[data-hfc-inchide]').forEach(function (b) { b.addEventListener('click', function () { inchide(false); }); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && deschisa) inchide(false); });

  r.querySelectorAll('[data-hfc-alege]').forEach(function (b) { b.addEventListener('click', deschideCutia); });

  /* Orice legătură către `#cadou`, de oriunde din pagină, deschide fereastra.
     Așa are subsolul unde să trimită omul, iar cine a închis-o o poate chema
     înapoi fără să aștepte cele 14 zile. */
  document.addEventListener('click', function (e) {
    var a = e.target.closest ? e.target.closest('a[href$="#cadou"]') : null;
    if (!a) return;
    e.preventDefault();
    if (deschisa) return;
    /* se ia de la primul pas, chiar dacă a mai umblat prin ea o dată */
    alegere.style.display = '';
    alegere.style.opacity = '';
    deschidere.className = 'hfc__deschidere';
    deschide();
  });

  r.querySelector('[data-hfc-mai-departe]').addEventListener('click', function () {
    arata(3);
    setTimeout(function () { var m = document.getElementById('hfcMail'); if (m) m.focus(); }, 120);
  });

  var trimite = r.querySelector('[data-hfc-trimite]');
  var eroare = r.querySelector('[data-hfc-eroare]');

  function gata(adresa) {
    pune(CHEIE_ABONAT, '1');
    arata(4);
    arunca(26);
    semnal('Fereastra cadou — a luat codul', { email: adresa });
  }

  trimite.addEventListener('click', function () {
    var camp = document.getElementById('hfcMail');
    var adresa = (camp.value || '').trim();

    if (!eAdresa(adresa)) {
      eroare.textContent = 'Scrie o adresă de e-mail întreagă, te rog.';
      eroare.hidden = false;
      camp.focus();
      return;
    }

    eroare.hidden = true;
    trimite.disabled = true;
    var scria = trimite.textContent;
    trimite.textContent = 'Se trimite…';

    /* ⚠️ Klaviyo răspunde 202 și pentru o adresă greșită — de asta adresa se
       verifică mai sus, nu din răspunsul lui. */
    aboneaza(adresa).then(function (rasp) {
      if (!rasp.ok) throw new Error('stare ' + rasp.status);
      gata(adresa);
    }).catch(function () {
      incercari++;
      trimite.disabled = false;
      trimite.textContent = scria;
      if (incercari >= 2) {
        /* A doua oară nu-l mai ținem în loc. Mai bine un cod dat degeaba decât
           un om pierdut în fața unui buton care nu merge. */
        gata(adresa);
        return;
      }
      eroare.textContent = 'Nu am putut trimite acum. Mai încearcă o dată.';
      eroare.hidden = false;
    });
  });

  var cod = r.querySelector('[data-hfc-copiaza]');
  var copiat = r.querySelector('[data-hfc-copiat]');
  if (cod) {
    cod.addEventListener('click', function () {
      var t = cod.textContent.trim();
      var arataCopiat = function () { copiat.hidden = false; setTimeout(function () { copiat.hidden = true; }, 2200); };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(t).then(arataCopiat).catch(function () { /* nimic */ });
      }
    });
  }

  /* ─── când apare ─── */

  /* ⚠️ REPARAT 9 octombrie 2026. `offsetParent` e ÎNTOTDEAUNA null pentru un
     element cu `position: fixed` — iar bannerul de cookie-uri al Shopify e fix.
     Deci paza de mai jos credea mereu că bannerul NU e pe ecran, și fereastra
     se deschidea peste el. Măsurat pe viu: se suprapuneau. Acum ne uităm la
     stilul calculat și la dreptunghi, care merg pentru orice poziționare. */
  function vazut(e) {
    if (!e) return false;
    var st = getComputedStyle(e);
    if (st.display === 'none' || st.visibility === 'hidden' || parseFloat(st.opacity) < 0.05) return false;
    var dr = e.getBoundingClientRect();
    return dr.width > 0 && dr.height > 0;
  }

  /* ⚠️ Niciodată peste bannerul de cookie-uri. Acolo omul dă un consimțământ,
     iar o fereastră care îl acoperă e și enervantă, și o problemă în sine.
     Se așteaptă până îl rezolvă — dar nu la nesfârșit. */
  function bannerSus() { return vazut(document.querySelector('#shopify-pc__banner')); }

  /* ⚠️ ȘI NICIODATĂ PESTE FEREASTRA KLAVIYO.
     Cât timp formularul lor (`UL7CPr`, cel cu meditația) e publicat, omul
     le-ar primi pe amândouă deodată — s-a și văzut, una peste alta. Formularele
     Klaviyo nu se pot opri prin API, doar din contul ei, deci fereastra asta se
     dă singură la o parte până dispare cealaltă. În clipa în care o stinge, a
     noastră își face treaba fără să mai umble nimeni la temă. */
  function klaviyoSus() { return vazut(document.querySelector('.klaviyo-form')); }

  /* 29 oct. 2026 — Xenia: „pe niciun magazin să nu apară pop-up-ul în timp ce faci un chestionar".
     Orice chestionar: al frecvențelor (#chest-card) și al frecvenței personalizate (hf-fp). Cât e pe ecran,
     fereastra așteaptă; cine l-a atins n-o mai vede pe pagina asta. (paza-chestionar.js) */
  var SEL_CHESTIONAR = '#chest-card, .hf-fp-section, [data-hf-fp-pas]';
  function chestionarPeEcran() {
    var q = document.querySelectorAll(SEL_CHESTIONAR);
    for (var i = 0; i < q.length; i++) {
      var dr = q[i].getBoundingClientRect();
      if (dr.width > 0 && dr.height > 0 && dr.bottom > 0 && dr.top < window.innerHeight) return true;
    }
    return false;
  }
  var inChestionar = false;
  function atingeChestionarul(e) { if (e.target && e.target.closest && e.target.closest(SEL_CHESTIONAR)) inChestionar = true; }
  document.addEventListener('click', atingeChestionarul, true);
  document.addEventListener('input', atingeChestionarul, true);

  function deschideCandSePoate(ramase) {
    if (deschisa || inChestionar) return;
    if ((bannerSus() || klaviyoSus() || chestionarPeEcran()) && ramase > 0) {
      setTimeout(function () { deschideCandSePoate(ramase - 1); }, 4000);
      return;
    }
    if (klaviyoSus() || chestionarPeEcran()) return;   /* a trecut vremea și tot e acolo — tăcem */
    deschide();
  }

  if (ia(CHEIE_ABONAT)) return;
  var inchisLa = parseInt(ia(CHEIE_INCHIS), 10);
  if (inchisLa && (Date.now() - inchisLa) < zile * 86400000) return;

  /* ⚠️ ADĂUGAT 9 octombrie 2026. Până acum socoteala se ținea doar dacă omul
     APĂSA pe închidere. Cine mergea mai departe prin site o primea DIN NOU la
     fiecare pagină — și se vedea în cifre: 1,02 pagini pe sesiune. Acum, odată
     arătată, tace 24 de ore, orice ar face omul cu ea. */
  var aratatLa = parseInt(ia(CHEIE_ARATAT), 10);
  if (aratatLa && (Date.now() - aratatLa) < 86400000) return;

  var cronometru = setTimeout(function () { deschideCandSePoate(45); }, intarziere * 1000);

  /* ⚠️ Nu e de ajuns să ne uităm o dată, înainte de a deschide: fereastra
     Klaviyo apare DUPĂ a noastră, și atunci se suprapun. S-a văzut cu ochii.
     Deci stăm de veghe: dacă apare cât timp a noastră e deschisă și omul încă
     n-a atins nimic, ne retragem tăcut și nu-i ținem socoteala zilelor. */
  var veghe = setInterval(function () {
    if (klaviyoSus() && deschisa) {
      var laInceput = r.querySelector('.hfc__pas--1.hfc--activ');
      if (laInceput) inchide(true);
    }
    if (performance.now() > 180000) clearInterval(veghe);
  }, 1500);

  if (laIesire && window.matchMedia('(min-width: 900px)').matches) {
    document.addEventListener('mouseout', function (e) {
      if (e.clientY <= 0 && !e.relatedTarget && !deschisa && !inChestionar && !chestionarPeEcran() && !bannerSus() && !klaviyoSus()) {
        clearTimeout(cronometru);
        deschide();
      }
    });
  }
})();

  } catch(e) { console.error(e); }
})();
})();
